import React from 'react';
import s from '../../Feature.module.scss';
import ContentfulImage from '../../../../../components/ContentfulImage';
import RichText from '../../../../../components/RichText';
import { RenderImageContext, RenderImageProps, ColumnsPhotoAlbum } from "react-photo-album";
import "react-photo-album/columns.css";
import { CaseStudyFeature } from '../../../../../constants/types';
import { removeInvalidImages, mapIconData } from '../../../../../utils/iconHelpers';

interface ViewType2Props {
  item: CaseStudyFeature;
}

function renderNextImage(porp: RenderImageProps, image: RenderImageContext) {
  const  { alt = "", title, sizes } = porp;
  const { photo, width, height } = image
  const fluid = {src: photo.src, aspectRatio: Number(title) ,sizes:'(max-width: 1000px) 100vw, 1000px', width, height}
  return (
    <ContentfulImage
    alt={alt}
    fluid={fluid}/>
  );
}

const ViewType2: React.FC<ViewType2Props> = ({ 
  item, 
}) => {
  const { description, imageSliders, hideTitle, title, backgroundColor } = item;
  
  const photos = removeInvalidImages(imageSliders || [])
    .map((icon) => {
      const mapped = mapIconData(icon);
      return {
        ...mapped,
        src: mapped.url,
      };
    });

  return (
    <div className={s.root}>
      <div
        className={[s.viewType2, s.container].join(' ')}
        style={{ background: backgroundColor || '' }}
        data-testid="viewtype2-container"
      >
        <div className={s.container}>
          <div className={s.subContainer}>
            <div className={s.textBlock}>
              {!hideTitle && (
                <h2 className={s.title} data-testid="viewtype2-title">
                  {title}
                </h2>
              )}
              <div className={s.content} data-testid="viewtype2-content">
                {description && <RichText data={description}/>}
              </div>
            </div>
          </div>
            <ColumnsPhotoAlbum photos={photos} render={{ image: renderNextImage }}>
            </ColumnsPhotoAlbum>
        </div>
      </div>
    </div>
  );
};

export default ViewType2;
